import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { useCompanyWithGroupData } from '@/composables/useCompanyWithGroupData';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyGroupForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { companiesWithGroupOptions } = useCompanyWithGroupData();

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "name",
      label: "company-groups.form.labels.name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          autocomplete: "name",
          placeholder: _ctx.$t('company-groups.form.labels.name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "companyIds",
      label: "company-groups.form.labels.companies"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.companyIds,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.companyIds) = $event)),
          options: _unref(companiesWithGroupOptions),
          translate: false,
          placeholder: _ctx.$t('company-groups.form.labels.companies'),
          loading: !_unref(companiesWithGroupOptions).length
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})